<template>
  <div class="container-fluid">
    <div class="row around-xs">
      <div class="col-xs-12 col-md-5">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CenetredContainer',
};
</script>
<style lang="scss" scoped>

</style>
